module.exports = __webpack_public_path__ + "img/89.294b5e5d.png";